import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  data: "",
  token: null,
  email: "",
  userData: "",
  weekelystats: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLogin: (state, action) => {
      const { data, token } = action.payload;
      state.isLoggedIn = true;
      state.data = data;
      state.token = token;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },

    setUserData: (state, action) => {
      state.userData = action.payload;
    },

    updateUserData: (state, action) => {
      state.userData.userName = action.payload;
    },

    setWeekelyStats: (state, action) => {
      state.weekelystats = action.payload;
    },

    userLogout: (state) => {
      localStorage.clear();
      state.isLoggedIn = false;
      state.data = "";
      state.userData = "";
      state.token = null;
    },
  },
});

export const {
  updateUserData,
  userLogin,
  userLogout,
  setUserData,
  setToken,
  setUserImage,
  setWeekelyStats,
} = authSlice.actions;

export default authSlice.reducer;
